import React, { createContext, useContext, useState, ReactNode } from "react";
import themeV1 from "./theme-v1.json";

export interface ThemeColor {
  name: string;
  hex: string;
}

export interface ThemeColors {
  primary: {
    [key: string]: string;
  };
  primaryvariant1: {
    [key: string]: string;
  };
  secondary: {
    [key: string]: string;
  };
  secondaryvariant1: {
    [key: string]: string;
  };
  secondaryvariant2: {
    [key: string]: string;
  };
  background: {
    [key: string]: string;
  };
  surface: {
    [key: string]: string;
  };
  accent1: {
    [key: string]: string;
  };
  accent2: {
    [key: string]: string;
  };
  accent3: {
    [key: string]: string;
  };
  accent4: {
    [key: string]: string;
  };
  accent5: {
    [key: string]: string;
  };
}

export interface Theme {
  name: string;
  author: string;
  colors: ThemeColors;
}

export interface ThemeContextType {
  theme: Theme;
  setTheme: (theme: Theme) => void;
}

const ThemeContext = createContext<ThemeContextType | undefined>(undefined);

interface ThemeProviderProps {
  children: ReactNode;
  initialTheme?: Theme;
}

export const ThemeProvider: React.FC<ThemeProviderProps> = ({
  children,
  initialTheme = themeV1 as Theme
}) => {
  const [theme, setTheme] = useState<Theme>(initialTheme);

  return (
    <ThemeContext.Provider value={{ theme, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = (): ThemeContextType => {
  const context = useContext(ThemeContext);
  if (context === undefined) {
    throw new Error("useTheme must be used within a ThemeProvider");
  }
  return context;
};

export default ThemeContext;
